import { OFFER_KIND } from './constants'

export const compareByKind = (a, b) => {
  const kindOrder = { [OFFER_KIND.PREMIUM]: 1, [OFFER_KIND.NORMAL]: 2 }
  return kindOrder[a.kind] - kindOrder[b.kind]
}
